import {
  ActionValidation,
  BooleanValidation,
  StringValidation,
} from '../../../../utils/component-validations';
import { action } from '@ember/object';
import { on } from '@ember/modifier';
import { reads } from 'macro-decorators';
import { tracked } from '@glimmer/tracking';
import Button from '../button.gjs';
import Super from '../base.gjs';
import styles from './item.module.scss';

const ROLE_DEFAULT = 'option';

export default class SpdsCoreMenuItem extends Super {
  arguments = [
    new ActionValidation({ required: ['onClick'] }),
    new BooleanValidation({ optional: ['showSelectedStyles', 'wrappedContent'] }),
    new StringValidation({ optional: ['role', 'value'] }),
  ];
  baseClass = 'spds-menu-item';
  classesToMapToArgs = ['hidden'];
  styles = styles;

  @tracked isSelected = 'false';

  @reads('baseElement.ariaSelected') ariaSelected;

  get keepSelectedState() {
    return this.ariaSelected === 'true' && this.args.retainSelection;
  }

  get showSelectedStyles() {
    return this.args.showSelectedStyles ?? true;
  }

  get role() {
    return this.args.role ?? ROLE_DEFAULT;
  }

  @action
  onClick() {
    if (this.showSelectedStyles && !this.keepSelectedState) {
      this.isSelected = `${this.ariaSelected === 'false'}`;
    }

    this.args.onClick(...arguments);
  }

  <template>
    <Button
      aria-current={{this.isSelected}}
      aria-selected={{this.isSelected}}
      class={{this.classes}}
      data-test-spds-menu-item
      data-value={{@value}}
      id={{this.id}}
      role={{this.role}}
      type="button"
      ...attributes
      {{this.setupComponent}}
      {{this.validateArguments}}
      {{on "click" this.onClick}}
    >
      {{#if @wrappedContent}}
        <span>{{yield}}</span>
      {{else}}
        {{yield}}
      {{/if}}
    </Button>
  </template>
}
